// Maximum allowed size for a single uploaded file and for the combined size
// of all files under a single training (in bytes). Keep in sync with backend
// configuration (api-backend/src/file/forms/UploadForm.php).
export const MAX_FILE_SIZE_BYTES = 500 * 1024 * 1024;
export const MAX_TRAINING_FILES_SIZE_BYTES = 500 * 1024 * 1024;

export function formatFileSizeMb (bytes) {
    return `${(bytes / (1024 * 1024)).toFixed(0)} MB`;
}

// Drops to KB below a megabyte so the counter of a small upload still moves.
export function formatFileSize (bytes) {
    const size = bytes || 0;

    if (size < 1024 * 1024) {
        return `${Math.round(size / 1024)} KB`;
    }

    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}



// WEBPACK FOOTER //
// ./src/app/components/file/fileConstants.js